<template lang="pug">
  v-card.user-page
    portal(to='toolbar')
      v-toolbar-title User Details / Training Exams
    .body.inner-scroll
      list(
        :loading="listLoading"
        :list="list"
        :pagination="pagination"
        :headers="headers"
        disable-sorting
        hide-select
        hide-actions
        v-slot="{item}"
        @loadMoreClick="loadListMore"
      )
        td.pl-4.w-50 {{ item.subchapter.id }}
        td.pl-4 {{ item.subchapter.name }}
        td.px-4.d-flex.justify-end.w-120 {{ item.created | formattedDate }}
</template>

<script>
import {UsersService} from "@/app/exercise/modules/users/core/users-service";
import {UserTabMixin} from "../mixins/user-tab.mixin";

export default {
  mixins: [UserTabMixin],
  data() {
    return {
      headers: [
        { text: 'ID', align: 'left', class: 'pl-4 w-50'},
        { text: 'Chapter', align: 'left', class: 'pl-4'},
        { text: 'Date', align: 'right', class: 'px-4 w-120' },
      ]
    }
  },
  created() {
    this.svc = new UsersService(this.$auth);
    this.loadFromApi = this.svc.loadUserExams;
  },
}
</script>

<style lang="scss" scoped>
  @import "../assets/users-tab-style";
</style>
